import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import classNames from "../../../utils/classNames";
import "./BandsReturnToDiscoverButton.scss";

const ChevronLeftIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
        <path d="M15 6l-6 6 6 6" />
    </svg>
);

export default function BandsReturnToDiscoverButton({ onClick, className = "" }) {
    const { t } = useTranslation();

    if (typeof onClick !== "function") {
        return null;
    }

    return (
        <button
            type="button"
            className={classNames("bands-return-to-discover", className)}
            onClick={onClick}
        >
            <ChevronLeftIcon />
            <span>{t("bandsWelcomePage.returnToDiscover")}</span>
        </button>
    );
}

BandsReturnToDiscoverButton.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
};
